import React, { useEffect, useState } from 'react'
import { Container, Button, Col, Row, Card, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, Input, } from 'reactstrap'
import { connect } from 'react-redux';
import BackButton from '../../../../../../../../designUtils/Logo/BackButton.svg'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import ReactTable from 'react-table';
import UploadCMAssetsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/UploadCMAssetsService';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';

function UploadProjectDashImages(props) {
  const [isCheckedImg, setIsCheckedImg] = useState(false);
  const [isCheckedAi, setIsCheckedAi] = useState(false);
  const [selectedImageFiles, setSelectedImageFiles] = useState([]);
  const [selectedGraphicFiles, setSelectedGraphicFiles] = useState([]);
  const [dragging, setDragging] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertMessageAi, setAlertMessageAi] = useState('');
  const [handleLinkFile, setHandleLinkFile] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false)
  const [destinationSubCategories, setDestinationSubCategories] = useState('');
  const [isDuplicatePopupOpen, setIsDuplicatePopupOpen] = useState(false);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [duplicateFileName, setDuplicateFileName] = useState('');
  const [duplicateFileType, setDuplicateFileType] = useState(''); // 'image' or 'graphic'
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  // Function to check for duplicate files
  const checkForDuplicates = (newFiles, fileType) => {
    const duplicates = [];
    
    newFiles.forEach(newFile => {
      if (fileType === 'image') {
        // Check against currently selected image files
        const matchingSelectedFiles = selectedImageFiles.filter(f => f.name === newFile.name);
        matchingSelectedFiles.forEach(matchingFile => {
          duplicates.push({
            fileName: newFile.name,
            newFileName: newFile.name,
            existingFileId: null,
            existingFileName: matchingFile.name,
            source: 'selected',
            assetList: [] // No asset mapping for selected files
          });
        });
  
        // Check against existing original files (images)
        const matchingOriginalFiles = (props.allOriginalFiles || []).filter(f => {
          const extension = f.actualFileName.toLowerCase().split('.').pop();
          return ['jpg', 'png', 'jpeg'].includes(extension) && f.actualFileName === newFile.name;
        });
        matchingOriginalFiles.forEach(matchingFile => {
          duplicates.push({
            fileName: newFile.name,
            newFileName: newFile.name,
            existingFileId: matchingFile.id,
            existingFileName: matchingFile.actualFileName,
            source: 'existing',
            assetList: matchingFile.assetList || [] // Asset list from backend
          });
        });
      } else if (fileType === 'graphic') {
        // Check against currently selected graphic files
        const matchingSelectedFiles = selectedGraphicFiles.filter(f => f.name === newFile.name);
        matchingSelectedFiles.forEach(matchingFile => {
          duplicates.push({
            fileName: newFile.name,
            newFileName: newFile.name,
            existingFileId: null,
            existingFileName: matchingFile.name,
            source: 'selected',
            assetList: []
          });
        });
  
        // Check against existing original files (graphics)
        const matchingOriginalFiles = (props.allOriginalFiles || []).filter(f => {
          const extension = f.actualFileName.toLowerCase().split('.').pop();
          return ['ai', 'psd', 'eps'].includes(extension) && f.actualFileName === newFile.name;
        });
        matchingOriginalFiles.forEach(matchingFile => {
          duplicates.push({
            fileName: newFile.name,
            newFileName: newFile.name,
            existingFileId: matchingFile.id,
            existingFileName: matchingFile.actualFileName,
            source: 'existing',
            assetList: matchingFile.assetList || []
          });
        });
      }
    });
    
    return duplicates;
  };

  // Function to add image files after duplicate check
  const addImageFilesAfterCheck = (filesToAdd) => {
    const allowedExtensions = ['png', 'jpg', 'jpeg'];

    const filteredFiles = filesToAdd.filter(file => {
      const extension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });

    setSelectedImageFiles(prevFiles => [...prevFiles, ...filteredFiles]);

    const invalidFiles = filesToAdd.filter(file => 
      !allowedExtensions.includes(file.name.split('.').pop().toLowerCase())
    );

    if (invalidFiles.length > 0) {
      setAlertMessage(`Invalid file(s) detected: ${invalidFiles.map(file => file.name).join(', ')}. Only PNG, JPG, and JPEG files are allowed.`);
    } else {
      setAlertMessage('');
    }
  };

  // Function to add graphic files after duplicate check
  const addGraphicFilesAfterCheck = (filesToAdd) => {
    const allowedExtensions = ['ai', 'psd', 'eps'];
    
    const filteredFiles = filesToAdd.filter(file => {
      const extension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });

    if (selectedGraphicFiles.length < 1) {
      setSelectedGraphicFiles(prevFiles => [...prevFiles, ...filteredFiles]);

      const invalidFiles = filesToAdd.filter(file => 
        !allowedExtensions.includes(file.name.split('.').pop().toLowerCase())
      );

      if (invalidFiles.length > 0) {
        setAlertMessageAi(`Invalid file(s) detected: ${invalidFiles.map(file => file.name).join(', ')}. Only ai, psd and eps files are allowed.`);
      } else {
        setAlertMessageAi('');
      }
    } else {
      setAlertMessageAi('You can only select one file at a time. Please remove the existing file before selecting a new one.');
    }
  };

  // Handle duplicate confirmation
  const handleDuplicateConfirmation = (proceed) => {
    if (proceed) {
      if (duplicateFileType === 'image') {
        addImageFilesAfterCheck(pendingFiles);
      } else if (duplicateFileType === 'graphic') {
        addGraphicFilesAfterCheck(pendingFiles);
      }
    }
    setIsDuplicatePopupOpen(false);
    setPendingFiles([]);
    setDuplicateFiles([]); // Clear duplicate files array
    setDuplicateFileName('');
    setDuplicateFileType('');
    
    // Clear the file inputs to allow re-selection of the same file
    const imageInput = document.getElementById("fileInput");
    const graphicInput = document.getElementById("graphicFileInput");
    if (imageInput) imageInput.value = '';
    if (graphicInput) graphicInput.value = '';
  };
  

  const handleRemoveFile = (file) => {
    const updatedFiles = selectedImageFiles.filter((f) => f !== file);
    setSelectedImageFiles(updatedFiles);
  };

  const handleGraphicRemoveFile = (file) => {
    const updatedFiles = selectedGraphicFiles.filter((f) => f !== file);
    setSelectedGraphicFiles(updatedFiles);
  };

  // Updated handleGraphicFileChange with duplicate detection
  const handleGraphicFileChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Check for duplicates with detailed information
    const duplicates = checkForDuplicates(files, 'graphic');
    
    if (duplicates.length > 0) {
      setPendingFiles(files);
      setDuplicateFiles(duplicates); // Store all duplicate details
      setDuplicateFileName(duplicates[0].fileName);
      setDuplicateFileType('graphic');
      setIsDuplicatePopupOpen(true);
      return;
    }
    
    // If no duplicates, proceed normally
    addGraphicFilesAfterCheck(files);
    
    // Clear the file input after processing
    e.target.value = '';
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Check for duplicates with detailed information
    const duplicates = checkForDuplicates(files, 'image');
    
    if (duplicates.length > 0) {
      setPendingFiles(files);
      setDuplicateFiles(duplicates);
      setDuplicateFileName(duplicates[0].fileName);
      setDuplicateFileType('image');
      setIsDuplicatePopupOpen(true);
      return;
    }
    
    // If no duplicates, proceed normally
    addImageFilesAfterCheck(files);
    e.target.value = '';
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);

    const files = Array.from(e.dataTransfer.files);
    
    // Check for duplicates with detailed information
    const duplicates = checkForDuplicates(files, 'image');
    
    if (duplicates.length > 0) {
      setPendingFiles(files);
      setDuplicateFiles(duplicates);
      setDuplicateFileName(duplicates[0].fileName);
      setDuplicateFileType('image');
      setIsDuplicatePopupOpen(true);
      return;
    }
    
    addImageFilesAfterCheck(files);
  };

  const handleGADragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleGADragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleBackFromUploadAssets = () => {
    if (props.handleBackFromUploadAssets) {
      props.handleBackFromUploadAssets();
    }
  };

  const handleGADragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };
  
  // Updated handleGADrop with duplicate detection
  const handleGADrop = (e) => {
    e.preventDefault();
    setDragging(false);
  
    const files = Array.from(e.dataTransfer.files);
    
    // Check for duplicates with detailed information
    const duplicates = checkForDuplicates(files, 'graphic');
    
    if (duplicates.length > 0) {
      setPendingFiles(files);
      setDuplicateFiles(duplicates); // Store all duplicate details
      setDuplicateFileName(duplicates[0].fileName);
      setDuplicateFileType('graphic');
      setIsDuplicatePopupOpen(true);
      return;
    }
    
    // If no duplicates, proceed normally
    addGraphicFilesAfterCheck(files);
  };
  
  const handleSubmitFile = () => {
    setLoadingButton(true);
    if (selectedImageFiles.length < 1 && selectedGraphicFiles.length < 1) {
      setAlertMessage('Please select at least one image or graphic file.');
      setLoadingButton(false);
      return true;
    }
    const data = new FormData();
    data.append("integerId", props.selectedProjectData.integerId);
    data.append("assetCategory", props.selectedSubCategories ? props.selectedSubCategories.assetCategory : '');
    data.append("subCategoryId", props.selectedSubCategories ? props.selectedSubCategories.id : '');
    data.append("assetIdentifier",  props.assetIdentifier ? props.assetIdentifier : '');
    const asinValue = (props.selectedASIN === 'Unmapped Assets' || !props.selectedASIN) ? '' : props.selectedASIN;
    data.append("asinList", asinValue);
    // data.append("asinList", props.selectedASIN ? props.selectedASIN : '');
    data.append("projectId", props.selectedProjectData.projectId ? props.selectedProjectData.projectId : '');
    data.append("notes", '');
    data.append("status", 1);
    data.append('destinationSubCategories', destinationSubCategories ? destinationSubCategories : '');
  
    if (selectedImageFiles.length > 0) {
      for (let i = 0; i < selectedImageFiles.length; i++) {
        data.append("attachmentFiles", selectedImageFiles[i]);
      }
      if (selectedGraphicFiles.length < 1) {
        data.append("attachmentFiles1", 0);
      }
      if (handleLinkFile != false) {
        data.append("handleLinkFile", handleLinkFile);
      } else {
        data.append("handleLinkFile", 0);
      }
    }
  
    if (selectedGraphicFiles.length > 0) {
      for (let i = 0; i < selectedGraphicFiles.length; i++) {
        data.append("attachmentFiles1", selectedGraphicFiles[i]);
      }
      if (selectedImageFiles.length < 1) {
        data.append("attachmentFiles", 0);
        data.append("handleLinkFile", 0);
      }
    }
  
    UploadCMAssetsService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        console.log("Response fileList:", res.fileList, "Original Files:", res.originalFiles);
        setSelectedImageFiles([]);
        setSelectedGraphicFiles([]);
        setHandleLinkFile(false);
        setLoadingButton(false);
        // Only update fileList if image files were uploaded
        if (selectedImageFiles.length > 0) {
        
            props.setFileList(res.fileList);
        }
        if (res.updatedAsinCount) {
          console.log("Updated ASIN count:", res.updatedAsinCount);
          props.setAsinAssetCounts(prevCounts => ({
            ...prevCounts,              // Keep all existing counts
            ...res.updatedAsinCount     // Update only the uploaded ASIN
          }));
        }
        // Always update originalFiles for graphics
        props.setAllOriginalFiles(res.originalFiles);
        handleBackFromUploadAssets();
      }
      if (res.assetStatusCount) {
        props.setAssetsStatusCount(res.assetStatusCount);
      }
      props.setSelectedASIN(null)
    })
  };

const columns = [
        {
            Header:'Id',
            accessor:'id',
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100 ">
                <p className="m-0">{cellInfo.value}</p>
              </div>
            ),
          },
          {
            Header:'File Name',
            accessor:'actualFileName',
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100 ">
                <p className="m-0">{cellInfo.value}</p>
              </div>
            ),
          },
          {
            Header:'Uploaded At',
            accessor:'createdAt',
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100 ">
                <p className="m-0">{cellInfo.value}</p>
              </div>
            ),
          },
        
    ]

  return (
    <>
      <Card className='p-2'>
        <Row>
          <Col>
            <h6>
              <button onClick={() =>handleBackFromUploadAssets()} className=" back-btn mr-1 "  >
                <img src={BackButton} alt="not found" />
              </button>
              &nbsp;<b>{props.selectedASIN} &nbsp; Assets</b>
            </h6>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <label className='ml-4'>
              <input
                type="checkbox"
                checked={isCheckedImg}
                onChange={(e) => setIsCheckedImg(e.target.checked)}
              />&nbsp;&nbsp;&nbsp;
              <b>Upload Images</b>
              <p className='ml-4'>Supported File (png,jpg,jpeg)</p>
            </label>
            <Row className=' justify-content-between'>
          {
            isCheckedImg ?
              <Col
                md={10}
                className="p-4 ml-4 dotted-box-upload-product"

              >
                <div
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}>


                  <label htmlFor="fileInput" className={`custom-brand-file-input text-center uploadfile ${dragging ? "dragging" : ""}`}>
                    <h5>
                      <FontAwesomeIcon icon={faCloudUploadAlt} style={{ fontSize: "30px" }} />
                    </h5>
                    <h5>Drag &amp; Drop Files </h5>
                    <h5>OR</h5>
                    <input type="file" id="fileInput" name="ticketAttachment" className="custom-brand-file" onChange={handleFileChange} style={{ display: "none" }} multiple/>
                    <Button onClick={() => document.getElementById("fileInput").click()} style={{ background: "#B2A1FF" }}>
                      Browse Files
                    </Button>
                  </label>
                  <p style={{ color: 'red' }}>{alertMessage}</p>
                  <p style={{ fontSize: "13px" }}>Attached File List</p>
                  <ul style={{ color: "green", fontSize: "13px" }}>
                    {selectedImageFiles.length > 0 ? (
                      selectedImageFiles.map((file, index) => (
                        <li key={index}>
                          {file.name}
                          <button className="btn" onClick={() => handleRemoveFile(file)}>
                            <FontAwesomeIcon color="red" size="15px" icon={faWindowClose} />
                          </button>
                        </li>
                      ))
                    ) : (
                      <li>No files attached</li>
                    )}
                  </ul>
                </div>
              </Col> : ''
          }
          {isCheckedAi ?
            <>
              {isCheckedImg ? '' : <Col md={12}>
              <ReactTable
                data={props.allOriginalFiles}
                columns={columns}
                className="-fixed -highlight -striped"
                getTheadProps={() => {
                  return {
                    style: {
                      overflowY: "hidden",
                      background: "#B1FA63",
                      color: "#243837",
                    },
                  };
                }}
                defaultPageSize={5}
                noDataText={"No Data Found."}
                />
              </Col>}
            </> : ''
          }

        </Row>
          </Col>
          <Col md={6} >
          <Row className="align-items-center ml-1 mt-2">
              <Col md={4}>
                <label><b>Destination Category:</b></label>
              </Col>
              <Col md={8}>
                <select
                  className="form-control"
                  value={destinationSubCategories}
                  onChange={(e) => setDestinationSubCategories(e.target.value)}
                >
                  <option value="">--Select--</option>
                  {props.existingSubCategories &&
                    props.existingSubCategories.map((subCategory) => (
                      <option key={subCategory.id} value={subCategory.id}>
                        {subCategory.subCategoryName}
                      </option>
                    ))}
                </select>
              </Col>
            </Row>

            <Row className="ml-1 mb-2 mt-3">
              <Col md={12}>
                <label className='ml-1'>
                  <input
                    type="checkbox"
                    checked={isCheckedAi}
                    onChange={(e) => setIsCheckedAi(e.target.checked)}
                  />&nbsp;&nbsp;&nbsp;
                  <b>Upload Editable Graphic File</b>
                  <p className='ml-4'>Supported File (ai, psd, eps)</p>
                </label>
              </Col>
            </Row>

            {isCheckedAi && (
              <Row className="ml-1 mb-2">
                <Col md={12}>
                  {isCheckedImg && (
                    <>
                      <select className="form-control w-100 mb-3" onChange={(e) => setHandleLinkFile(e.target.value)}>
                        <option value="">--Select Existing File--</option>
                        {props.allOriginalFiles && props.allOriginalFiles.map((file) => (
                          <option value={file.id} key={file.id}>{file.actualFileName}
                          &nbsp;&nbsp;
                          ({file.createdAtGraphics})</option>
                        ))}
                      </select>
                      {!handleLinkFile && <h5 className='text-center'>OR</h5>}
                    </>
                  )}

                  {!handleLinkFile && (
                    <div
                      onDrop={handleGADrop}
                      onDragOver={handleGADragOver}
                      onDragEnter={handleGADragEnter}
                      onDragLeave={handleGADragLeave}
                    >
                      <label htmlFor="graphicFileInput" className={`custom-brand-file-input text-center uploadfile ${dragging ? "dragging" : ""}`}>
                        <h5><FontAwesomeIcon icon={faCloudUploadAlt} style={{ fontSize: "30px" }} /></h5>
                        <h5>Drag & Drop Files </h5>
                        <h5>OR</h5>
                        <input
                          type="file"
                          id="graphicFileInput"
                          className="custom-brand-file"
                          onChange={handleGraphicFileChange}
                          style={{ display: "none" }}
                          multiple
                        />
                        <Button onClick={() => document.getElementById("graphicFileInput").click()} style={{ background: "#B2A1FF" }}>
                          Browse Files
                        </Button>
                      </label>
                      <p style={{ color: 'red' }}>{alertMessageAi}</p>
                      <p style={{ fontSize: "13px" }}>Attached File List</p>
                      <ul style={{ color: "green", fontSize: "13px" }}>
                        {selectedGraphicFiles.length > 0 ? (
                          selectedGraphicFiles.map((file, index) => (
                            <li key={index}>
                              {file.name}
                              <button className="btn" onClick={() => handleGraphicRemoveFile(file)}>
                                <FontAwesomeIcon color="red" size="15px" icon={faWindowClose} />
                              </button>
                            </li>
                          ))
                        ) : (
                          <li>No files attached</li>
                        )}
                      </ul>
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
       
        <Row>
          <Col md={12}>
            <div className='d-flex justify-content-center m-3'>
              {isCheckedImg || isCheckedAi ?<Button className='btn-background-color-Proceed-gallery' 
              disabled={(selectedImageFiles.length < 1 && selectedGraphicFiles.length < 1) || loadingButton}
              onClick={() => handleSubmitFile()}>
                {loadingButton==true?'Submitting':'Submit'}</Button>:''}
            </div>
          </Col>
        </Row>
      </Card>

      {/* Duplicate File Confirmation Popup */}
      <CustomModal
  header={'Duplicate File Warning'}
  isOpen={isDuplicatePopupOpen}
  toggle={() => setIsDuplicatePopupOpen(!isDuplicatePopupOpen)}
  size={"md"}
  className="curve-popup"
>
  <div className="modal-body">
    {(() => {
      // Group duplicate files by filename and combine asset lists
      const groupedFiles = duplicateFiles.reduce((acc, duplicate) => {
        const fileName = duplicate.fileName;
        if (!acc[fileName]) {
          acc[fileName] = {
            fileName: fileName,
            assetList: []
          };
        }
        if (duplicate.assetList && duplicate.assetList.length > 0) {
          acc[fileName].assetList = [...acc[fileName].assetList, ...duplicate.assetList];
        }
        return acc;
      }, {});
      
      const uniqueFiles = Object.values(groupedFiles);
      
      return uniqueFiles.map((fileData, index) => (
        <div key={index} className="mb-2 modal-body">
          <p>"{fileData.fileName}" already exists.</p>
          {fileData.assetList && fileData.assetList.length > 0 && (
            <div>
              <p>The existing file is already mapped to the following assets:</p>
              <div className="mb-3">
                <strong>Asset List:</strong>
                <ul className="mt-2">
                  {fileData.assetList.map((asset, assetIndex) => (
                    <li key={assetIndex}>
                      Asset ID: {typeof asset === 'object' ? asset.id : asset} | Name: {typeof asset === 'object' ? asset.name : '(Asset Name)'}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          
          <p className='mt-3'>Do you want to replace it? Please note replace action will update mapping for existing assets.</p>
        </div>
      ));
    })()}
    
    <div className='mb-2 d-flex justify-content-end mr-2'>
      <Button 
        className="no-btn-background-color"  
        onClick={() => handleDuplicateConfirmation(false)} 
      >
        No
      </Button>   &nbsp;
      <Button
        className='btn-background-color'
        onClick={() => handleDuplicateConfirmation(true)} 
        style={{ marginLeft: "10px" }}
      >
        Yes
      </Button>
    </div>
  </div>
</CustomModal>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    storeOverview: state.accountOverview.store.storeOverview,
  };
};

export default connect(mapStateToProps)(UploadProjectDashImages)